import { Dispatch, SetStateAction, memo, useState } from 'react';
import { IOrder, IOrderPaymentLines } from '../../../interfaces/Order';
import { ActionIcon, Grid, Menu, rem, Text, Tooltip } from '@mantine/core';
import moment from 'moment';
import { type MRT_PaginationState } from 'mantine-react-table';
import { useTranslation } from 'react-i18next';
import { formatMoneyString, getCustomerFullName, getFullPhoneNumber } from '../../../utils/strings';
import Table from '../../../components/Table';
import OrderStatuses from '../../../enum/OrderStatuses';
import { IconCurrencyDollar } from '@tabler/icons-react';
import { buildOrderFolio } from '../../../utils/ordersUtils';

export default memo(function TableView({
  tableInfo = [],
  totalRowsCount = 0,
  pages = 0,
  isError = false,
  isLoading = false,
  pagination,
  setPagination,
  footerInfo = {
    totalAmount: 0,
    totalAmountPaid: 0,
    totalRowsCount: 0,
    totalUnpaidAmount: 0
  },
  setEditingOrder = () => {}
}: {
  setEditingOrder: any;
  tableInfo: any[];
  footerInfo: {
    totalAmount: number;
    totalAmountPaid: number;
    totalRowsCount: number;
    totalUnpaidAmount: number;
  };
  totalRowsCount: any;
  pages: any;
  isError: boolean;
  isLoading: boolean;
  pagination: MRT_PaginationState;
  setPagination: Dispatch<SetStateAction<MRT_PaginationState>>;
}) {
  const { t } = useTranslation(['FieldName']);
  const columns = [
    {
      accessorFn: (row) => buildOrderFolio((row as unknown as IOrder)?.folioPrefix, (row as unknown as IOrder)?.sequence),
      header: t('FieldName:order')
    },
    {
      accessorFn: (row) => `${formatMoneyString(row.total.toFixed(2))}`,
      header: t('FieldName:total'),
      Footer: () => {
        return (
          <Grid>
            <Grid.Col span={12}>
              <Text fw={'bold'}>{formatMoneyString(footerInfo?.totalAmount.toFixed(2))}</Text>
            </Grid.Col>
          </Grid>
        );
      }
    },
    {
      accessorFn: (row) => `${formatMoneyString(row.unpaidAmountRes.toFixed(2))}`,
      header: t('FieldName:amountDue'),
      Footer: () => {
        return (
          <Grid>
            <Grid.Col span={12}>
              <Text fw={'bold'}>{formatMoneyString(footerInfo?.totalUnpaidAmount.toFixed(2))}</Text>
            </Grid.Col>
          </Grid>
        );
      }
    },
    {
      accessorFn: (row) => t(`FieldName:orderStatuses.${OrderStatuses[row.status.toUpperCase()]}`),
      header: t('FieldName:status')
    },
    {
      accessorFn: (row) => moment(row.createdDate).format('DD/MM/YYYY hh:mm'),
      header: t('FieldName:createdDate')
    },
    {
      accessorFn: (row) =>
        row.collectedDateTime
          ? moment(row.collectedDateTime).format('DD/MM/YYYY hh:mm')
          : 'Pendiente de Entrega',
      header: t('FieldName:collectedDate')
    },
    {
      accessorFn: (row) => `${getCustomerFullName(row.customer?.name, row.customer?.lastName)}`,
      header: t('FieldName:customer')
    },
    {
      accessorFn: (row) =>
        `${getFullPhoneNumber(row.customer?.phoneCountryCode, row.customer?.phone)}`,
      header: t('FieldName:phone')
    }
  ];

  return (
    <>
      <Grid gutter="md">
        <Grid.Col span={12}>
          <Table
            tableColumns={columns}
            pagination={pagination}
            setPagination={setPagination}
            tableData={tableInfo}
            isError={isError}
            paginationIsLoading={isLoading}
            numPages={pages}
            totalRowsCount={totalRowsCount}
            overrideTableConfigs={{
              enableTableFooter: true,
              enableRowActions: true,
              positionActionsColumn: 'first',
              renderRowActions: ({ row }) => {
                // <>
                //   <Menu.Item onClick={() => setEditingOrder(row)}>Registrar Pago</Menu.Item>
                // </>;
                return (
                  <Tooltip title="Registrar Pago" label="Registrar Pago">
                    <ActionIcon
                      radius={'none'}
                      variant="light"
                      aria-label="registrar pago"
                      size={'lg'}
                      onClick={() => {
                        setEditingOrder(row?.original);
                      }}>
                      <IconCurrencyDollar />
                    </ActionIcon>
                  </Tooltip>
                );
              }
            }}
          />
        </Grid.Col>
      </Grid>
    </>
  );
});
